import React, { createContext, useState, useEffect, ReactNode } from 'react';
import { CONFIG_BASE_DOMAIN , PAYMENT_CONFIG_BASE_DOMAIN, EMAIL_ACCESS_CONFIG_URL} from '../api-constant';
import { setRemoteEmailAccess } from '../../utils/emailAccessConfig';

type ConfigType = {
    [key: string]: any;
};

type PaymentConfigType = {
    [key: string]: any;
};

export const ConfigContext = createContext<ConfigType | null>(null);
export const PaymentConfigContext = createContext<PaymentConfigType | null>(null);

interface ConfigProviderProps {
    children: ReactNode;
}

export const ConfigProvider: React.FC<ConfigProviderProps> = ({ children }) => {
    const [config, setConfig] = useState<ConfigType | null>(null);
    const [paymentConfig, setPaymentConfig] = useState<PaymentConfigType | null>(null);

    useEffect(() => {
        fetch(`${CONFIG_BASE_DOMAIN}`)
            .then(response => response.json())
            .then(data => setConfig(data))
            .catch(error => console.error('Error fetching config:', error));
    }, []);

    useEffect(() => {
        fetch(`${PAYMENT_CONFIG_BASE_DOMAIN}`)
            .then(response => response.json())
            .then(data => setPaymentConfig(data))
            .catch(error => console.error('Error fetching Payment config:', error));
    }, []);

    useEffect(() => {
        if (!EMAIL_ACCESS_CONFIG_URL) return;
        fetch(EMAIL_ACCESS_CONFIG_URL)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`adminEmailAccess.json HTTP ${response.status}`);
                }
                return response.json();
            })
            .then((data) => setRemoteEmailAccess(data))
            .catch((error) =>
                console.error('Error fetching adminEmailAccess.json:', error)
            );
    }, []);

    return (
        <ConfigContext.Provider value={config}>
            <PaymentConfigContext.Provider value={paymentConfig}>
                {children}
            </PaymentConfigContext.Provider>
        </ConfigContext.Provider>
    );
};
